import { Outlet } from 'react-router'
import Header from '../../../component/layout/header'
import useNav from '../../../component/custom-hooks/get-nav';

const FleetVanLayout = () => {
  const navList = useNav();
  let {fleetTopHeader, fleetVanBottom} = navList;

  return (
    <div className="webBody">
      <Header bottomTabs={fleetVanBottom} topTabs={fleetTopHeader} />
      <Outlet />
    </div>
  )
}

export default FleetVanLayout